import { render, staticRenderFns } from "./NoUpcomingEventsCard.vue?vue&type=template&id=7dd5f8cc&"
import script from "./NoUpcomingEventsCard.vue?vue&type=script&lang=ts&"
export * from "./NoUpcomingEventsCard.vue?vue&type=script&lang=ts&"
import style0 from "./NoUpcomingEventsCard.vue?vue&type=style&index=0&id=7dd5f8cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
